<template>
    <div class="position-relative" v-bind:class="{'run-loading': loading}">
        <gofix-form-dropdown
            :class="[ 'highlightDropdown highlightDropdownMap min-width-0 width-270' ]"
            label=""
            :clearable="false"
            :filterable="false" 
            :options="jobStatus"
            v-model="filter.status"
            placeholder="Job Status">
            <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                <span class="text-hidden-one-row">Job Status: {{ option.label }}</span>
            </template>
            <template slot="gofixInput:dropdown:option" slot-scope="option">
                <div class="maintOption">
                    <span>{{ option.label }}</span>
                </div>
            </template>
        </gofix-form-dropdown>
        <template v-if="!['Due', 'Started'].includes(filter.status)">
            <div class="row no-gutters align-items-center boxHighlightDropdownDate">
                <span class="col-3 c-orange">Date:</span>
                <gofix-form-input-date
                    class="col-9 highlightDropdownDate"
                    desc=" "
                    v-model="filter.date"
                    label=" ">
                </gofix-form-input-date>
            </div>
        </template>
        
        <GmapMap
            :options="infoOptions" 
            :center="center"
            style="width:100%; height: calc(100vh - 57px);"
            >
            <GmapInfoWindow 
                :position="infoWindowJob.position" 
                :opened="infoWinOpen" 
                @closeclick="infoWinOpen = false">
                <div class="infoWindowBox">
                    <template v-for="(item, key) in infoWindowJob.jobs">
                        <div class="infoWindow mb-3" :key="key">
                            <h6 class="location mb-2">
                                <i class="fa fa-map-marker"></i> 
                                <span>{{ item.location ? item.location : '--' }}</span>
                            </h6>
                            <gofix-text-field label="Job Number:" class="mb-1" oneline>
                                <router-link class="link mt-0" target="_blank" :to="`/v2/job-list/${item.id}`">
                                    {{ item.job_number ? item.job_number : '--' }}
                                </router-link>
                            </gofix-text-field>
                            <gofix-text-field label="Planned Date:" class="mb-1" oneline>{{ item.planned_date ? item.planned_date : null | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}</gofix-text-field>
                            <gofix-text-field 
                                v-if="item.completed_by && item.completed_by.name"
                                label="Completed By:" 
                                class="mb-1" 
                                oneline>
                                {{ item.completed_by.name }}
                            </gofix-text-field>
                            <gofix-text-field 
                                v-if="item.completed_at"
                                label="Completed Date:" 
                                class="mb-1" 
                                oneline>
                                {{ item.completed_at | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                            </gofix-text-field>
                            <gofix-text-field 
                                v-if="item.accepted_by && item.accepted_by.name"
                                label="Verified By:" 
                                class="mb-1" 
                                oneline>
                                {{ item.accepted_by.name }}
                            </gofix-text-field>
                            <gofix-text-field 
                                v-if="item.verified_at"
                                label="Verified Date:" 
                                class="mb-1" 
                                oneline>
                                {{ item.verified_at | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                            </gofix-text-field>
                        </div>
                    </template>
                </div>
            </GmapInfoWindow>
            <GmapMarker
                :key="index"
                v-for="(marker, index) in markers"
                :position="marker.position"
                :icon="getMarkers(marker, index)"
                @click="toggleInfoWindow(marker, index)"
            ></GmapMarker>
        </GmapMap>
        <!-- center=position -->
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
    name: "job-map",
    data() {
        return {
            mapMarker: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMyIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDIzIDI5IiBmaWxsPSJub25lIj4NCjxwYXRoIGQ9Ik0yMyAxMS41QzIzIDIxLjUgMTEuNSAyOC41IDExLjUgMjguNUMxMS41IDI4LjUgMCAyMS41IDAgMTEuNUMwIDUuMTQ4NzMgNS4xNDg3MyAwIDExLjUgMEMxNy44NTEzIDAgMjMgNS4xNDg3MyAyMyAxMS41WiIgZmlsbD0iI0M3MDYyOSIvPg0KPGNpcmNsZSBjeD0iMTEuNSIgY3k9IjExLjUiIHI9IjUuNSIgZmlsbD0id2hpdGUiLz4NCjwvc3ZnPg==",
            mapMarkerActive: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMyIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDIzIDI5IiBmaWxsPSJub25lIj4NCjxwYXRoIGQ9Ik0yMyAxMS41QzIzIDIxLjUgMTEuNSAyOC41IDExLjUgMjguNUMxMS41IDI4LjUgMCAyMS41IDAgMTEuNUMwIDUuMTQ4NzMgNS4xNDg3MyAwIDExLjUgMEMxNy44NTEzIDAgMjMgNS4xNDg3MyAyMyAxMS41WiIgZmlsbD0iI2YwNTYwMCIvPg0KPGNpcmNsZSBjeD0iMTEuNSIgY3k9IjExLjUiIHI9IjUuNSIgZmlsbD0id2hpdGUiIHN0eWxlPSImIzEwOyAgICBiYWNrZ3JvdW5kOiAjZjA1NjAwMDg7JiMxMDsiLz4NCjwvc3ZnPg==",
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35
                },
                zoom: 12,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels",
                        stylers: [
                            { visibility: "off" }
                        ]
                    },
                    {
                        featureType: "transit",
                        elementType: "labels",
                        stylers: [
                            { visibility: "off" }
                        ]
                    }
                ],
            },
            infoWinOpen: false,
            infoWindowJob: {
                position: {
                    lat: 1.352083,
                    lng: 103.819839
                }
            },
            center: {
                lat: 1.352083,
                lng: 103.819839
            },
            selectedKey: null,
            markersRelated: [],
            markers: [],
            places: [],
            filter: {
                status: 'Due',
                date: null
            },
            jobStatus: ['Planned', 'Due', 'Started', 'Completed', 'Verified', 'End'],
            loading: false
        };
    },
    computed: {
        ...mapGetters({
            ClientContractID: 'ContractController/ClientContractID'
        }),
    },
    watch: {
        ClientContractID: {
            immediate: true,
            handler(val) {
                if(val && val.id) this.getJob();
                else {
                    this.resetData()
                }
            }
        },
        "filter.status": function(val) {
            if(val == 'Due' || val == 'Started') this.filter.date = null;
            else this.filter.date = moment().toDate();
            this.getJob();
        },
        "filter.date": function(old, val) {
            this.getJob();
        },
        infoWinOpen: function(val) {
            if(!val) this.selectedKey = null
        }
    },
    methods: {
        getMarkers(marker, index) {
            if (this.selectedKey === index || this.markersRelated.includes(marker.id)) return this.mapMarkerActive;
            return this.mapMarker;
        },
        toggleInfoWindow(marker, index) {            
            this.selectedKey = index;
            this.infoWindowJob = marker;
            if (this.currentMidx == marker.id) {
                this.infoWinOpen = !this.infoWinOpen;
            } else {
                this.infoWinOpen = true;
            }
        },
        resetData() {
            this.markers.splice(0);
            this.selectedKey = null;
            this.infoWinOpen = false;
            this.infoWindowJob = {
                position: {
                    lat: 1.352083,
                    lng: 103.819839
                }
            }
        },
        getJob() {
            if(this.filter.status != "Due" && this.filter.status != "Started" && !this.filter.date) return this.$alertNotification("Please select a date", "warning");
            this.resetData();
            this.loading = true;
            const request = {
                page: 1,
                limit: -1,
                isCMS: false,
                showRelationship: '1',
                filter: {
                    job_status: this.filter.status,
                    client_contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null,
                }
            }

            if(this.filter.date) {
                const dateRequest = moment(this.filter.date).format('YYYY-MM-DD');
                const valDate = {
                    type: "date",
                    value: dateRequest
                };
                switch (this.filter.status) {
                    case "Started":
                        request.filter.start_at = valDate;
                        break;
                    case "Completed":
                        request.filter.completed_at = valDate;
                        break;
                    case "Verified":
                        request.filter.verified_at = valDate;
                        break;
                    case "End":
                        request.filter.completed_at_manual = valDate;
                        break;
                    default:
                        request.filter.planned_date = dateRequest;
                }
            }

            this.$store.dispatch("JobController/getJobItems", request)
                .then(response => {
                    if(response.items && response.items.length) {
                        let places = {};
                        response.items.map(item => {
                            if(item.property && item.property.get_address && item.property.get_address.geo_location && item.property.get_address.geo_location.latitude && item.property.get_address.geo_location.longtitude) {
                                const lat = item.property.get_address.geo_location.latitude * 1;
                                const lng = item.property.get_address.geo_location.longtitude * 1;
                                const job = {
                                    id: item.id,
                                    job_number: item.job_number,
                                    location: item.location,
                                    planned_date: item.planned_date,
                                    completed_at: item.completed_at,
                                    verified_at: item.verified_at,
                                    completed_by: item.completed_by || null,
                                    accepted_by: item.accepted_by || null,
                                }

                                if(places[lat] && places[lat].lng && places[lat].lng == lng) {
                                    this.markers[places[lat].idx].jobs.push(job);
                                } else {
                                    places[lat] = {
                                        lng: lng,
                                        idx: this.markers.length
                                    }
                                    this.markers.push({
                                        position: { lat: lat, lng: lng },
                                        jobs: [job]
                                    })
                                }
                            }
                        })
                    }
                    
                    this.loading = false;
                })
                .catch(err => {
                    console.log(err)
                    this.loading = false;
                })
        }
    }
}
</script>